import React from 'react';

const ElegantReviewCard = ({ name, reviewText, shortText, profile, service }) => {
    const getInitials = (fullName) => {
        if (!fullName) return '';
        const parts = fullName.trim().split(' ');
        if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
        return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
    };

    return (
        <div dir="ltr" className="flex py-6 justify-center">
            <div className="w-full max-w-sm  lg:min-w-lg lg:max-w-lg">
                <div className="relative bg-white/95 dark:bg-slate-950/95 border border-slate-200/80 dark:border-slate-800/80 rounded-2xl shadow-[0_18px_45px_rgba(15,23,42,0.12)] overflow-hidden h-[300px] lg:h-[250px] flex flex-col justify-between">
                    <article className="custom-font px-7 pt-7 pb-6 flex flex-col gap-4">
                        {/* header row */}
                        <div className="flex items-center justify-between gap-4">
                            <div className="flex items-center gap-3">
                                <div className="flex items-center justify-center w-11 h-11 rounded-full bg-slate-900 text-white text-sm font-semibold tracking-wide">
                                    {profile ? (
                                        <img
                                            src={profile}
                                            alt={name}
                                            className="w-full h-full rounded-full object-cover"
                                        />
                                    ) : (
                                        <span>{getInitials(name)}</span>
                                    )}
                                </div>
                                <div className="flex flex-col">
                                    <p className="text-sm font-semibold tracking-wide text-slate-900 dark:text-slate-50">
                                        {name}
                                    </p>
                                    <p className="text-[11px] uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
                                        {service ? `${service} · Verified Client` : 'Verified Client'}
                                    </p>
                                </div>
                            </div>

                            <div className="flex flex-col items-end gap-1">
                                <div className="flex items-center gap-1">
                                    {[...Array(5)].map((_, index) => (
                                        <svg
                                            key={index}
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            className="w-4 h-4 text-amber-400"
                                        >
                                            <path d="M12 .587l3.668 7.431L24 9.748l-6 5.847L19.335 24 12 20.201 4.665 24 6 15.595 0 9.748l8.332-1.73L12 .587z" />
                                        </svg>
                                    ))}
                                </div>
                                <span className="text-[11px] tracking-[0.14em] text-slate-500 dark:text-slate-400 uppercase">
                                    5.0 / 5.0
                                </span>
                            </div>
                        </div>

                        {/* headline / short text */}
                        {shortText && (
                            <h3 className="mt-2 text-base font-medium  text-slate-900 dark:text-slate-50">
                                {shortText}
                            </h3>
                        )}

                        {/* review text */}
                        <div className="mt-2">
                            <p className="text-sm leading-relaxed text-slate-700 dark:text-slate-200 italic border-l border-slate-200/80 dark:border-slate-700/80 pl-4">
                                “{reviewText}”
                            </p>
                        </div>
                    </article>
                </div>
            </div>
        </div>
    );
};

export default ElegantReviewCard;